/**
 * ICAO passport data page — 88x125 mm, the size the PDF engine lays out.
 * Mirrors `nidCardConstants` so the shared live preview can be pointed at
 * either document without knowing which.
 */
export const PASSPORT_PAGE_MM = { w: 88, h: 125 };

/** A4 short edge (mm). */
const A4_SHORT_MM = 210;
/** A4 long edge (mm). */
const A4_LONG_MM = 297;

/** Live preview + PDF capture: mm → px with A4 short edge = 794px (same basis as NID). */
export const PASSPORT_A4_PREVIEW_PX_PER_MM = 794 / A4_SHORT_MM;

/** A4 preview canvas sizes (px); landscape is swap(w,h) of portrait. */
export const PASSPORT_PREVIEW_PORTRAIT = {
    w: Math.round(A4_SHORT_MM * PASSPORT_A4_PREVIEW_PX_PER_MM),
    h: Math.round(A4_LONG_MM * PASSPORT_A4_PREVIEW_PX_PER_MM),
};

export const PASSPORT_PREVIEW_LANDSCAPE = {
    w: PASSPORT_PREVIEW_PORTRAIT.h,
    h: PASSPORT_PREVIEW_PORTRAIT.w,
};

/**
 * How many copies fit one A4 page.
 *
 * A passport page is 88x125 mm — more than twice the area of an ID card — so
 * two pairs is the honest ceiling upright, and a turned page (90/270) is
 * 125 mm wide, where even a second pair stops reading well.
 */
export function passportMaxCopies(rotation) {
    const rot = ((Number(rotation) || 0) % 360 + 360) % 360;
    return rot === 90 || rot === 270 ? 1 : 2;
}
